import { useNavigate, useLocation } from 'react-router-dom';
import { useLocalizedPath } from '../../hooks/useLocalizedPath';
import styles from './LanguageSwitcher.module.css';

interface LanguageSwitcherProps {
  onNavigate?: () => void;
  variant?: 'light' | 'dark';
}

export function LanguageSwitcher({ onNavigate, variant = 'light' }: LanguageSwitcherProps) {
  const { lang, toOtherLang } = useLocalizedPath();
  const navigate = useNavigate();
  const location = useLocation();

  const switchLanguage = () => {
    const target = toOtherLang(location.pathname);
    navigate(target);
    onNavigate?.();
  };

  return (
    <div className={`${styles.switcher} ${styles[variant]}`}>
      <button
        className={`${styles.option} ${lang === 'fr' ? styles.active : ''}`}
        onClick={lang === 'fr' ? undefined : switchLanguage}
        aria-label="Français"
        aria-current={lang === 'fr' ? 'true' : undefined}
      >
        <span className={styles.flag} aria-hidden="true">🇫🇷</span>
        <span className={styles.label}>FR</span>
      </button>
      <button
        className={`${styles.option} ${lang === 'en' ? styles.active : ''}`}
        onClick={lang === 'en' ? undefined : switchLanguage}
        aria-label="English"
        aria-current={lang === 'en' ? 'true' : undefined}
      >
        <span className={styles.flag} aria-hidden="true">🇬🇧</span>
        <span className={styles.label}>EN</span>
      </button>
    </div>
  );
}
